import { CollectionReference, collection, doc, getDoc, getFirestore } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { SessionStatus } from '@/models';

import { safePromise } from './safePromise';

export interface RecordingTypeInDatabase {
  id: string;
  createdBy: string;
  dateCreated: string;
  icon: string;
  lastUpdated: string;
  name: string;
  priority: number;
  status: SessionStatus;
}

export const getFirebaseRecordingTypesByIds = async (ids: string[]): Promise<RecordingTypeInDatabase[] | undefined> => {
  if (ids.length === 0 || ids.some((id) => !id) || ids.some((id) => typeof id !== 'string')) {
    toast({
      variant: 'error',
      title: 'No recording types found',
      description: 'Please contact support',
    });

    console.error('Provided ids are invalid', ids);

    return undefined;
  }

  const firestore = getFirestore();
  const recordingTypesRef = collection(firestore, '_recordingTypes') as CollectionReference<RecordingTypeInDatabase>;

  const recordingTypesPromises = ids.map((id) => {
    return safePromise(getDoc(doc(recordingTypesRef, id)));
  });

  const recordingTypesResults = await Promise.all(recordingTypesPromises);
  const recordingTypesInDatabase: RecordingTypeInDatabase[] = [];

  for (const [docSnapshot, error] of recordingTypesResults) {
    if (error) {
      toast({
        variant: 'error',
        title: 'Something went wrong',
        description: 'Please try again later',
      });

      return undefined;
    } else if (docSnapshot.exists()) {
      recordingTypesInDatabase.push({
        ...docSnapshot.data(),
        id: docSnapshot.id,
      });
    }
  }

  if (recordingTypesInDatabase.length === 0) {
    toast({
      variant: 'error',
      title: 'No recording types found',
      description: 'Please contact support',
    });
  }

  return recordingTypesInDatabase;
};
